export default {
    init() {
        // JavaScript to be fired on the checkout page

        $(document).ready(function(){
            $('.ed-manual-update-cart-button').click(function(){
                $('.actions').find('.update-cart-button').click();
            });
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/cart.js